<template>
	<v-text-field v-bind="$attrs"
	              v-model="model"
                :disabled="disabled"
	              @change="onModelUpdated"
	              type="text"
	              :prefix="currencySymbol"
	              :rules="moneyRules">
		<template #prepend>
			<slot name="prepend">
			</slot>
		</template>
		<template #append>
			<slot name="append">
			</slot>
		</template>
	</v-text-field>
</template>

<script lang="ts">
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import MoneyHelper from "../services/moneyHelper";

@Component
export default class MoneyInput extends Vue {
	@Prop() value: any;
	@Prop() rules: any[];
  @Prop({ type: Boolean }) disabled;

	@Emit() input() {
		return this.parseNumber(this.model);
	}

	model: string | number = null;

	get moneyRules() {
		return [this.moneyRule].concat(this.rules || []);
	}

	get currencySymbol() {
		return this.$vopsui.options.currencySymbol();
	}

	get currencyDecimalDigits() {
		return this.$vopsui.options.currencyDecimalDigits();
	}

	get currencyGroupSeparator() {
		return this.$vopsui.options.currencyGroupSeparator();
	}

	get currencyDecimalSeparator() {
		return this.$vopsui.options.currencyDecimalSeparator();
	}

	@Watch('value', {immediate: true})
	onValueUpdated(value) {
		const formatted = this.formatNumber(value);
		if (formatted == this.model)
			return;
		this.model = formatted;
	}

	onModelUpdated() {
		this.input();
	}

	moneyRule(value: any) {
		if (value == null || value === '')
			return true;
		const number = MoneyHelper.parseCurrency(value, this.currencyGroupSeparator, this.currencyDecimalSeparator);
		const regex = new RegExp(`^(\-?\\d*\\.?\\d{0,${this.currencyDecimalDigits}})$`);
		return regex.test(number as any) || this.$vopsui.labels.invalidCurrency();
	}

	private parseNumber(value: string | number) {
		if (value == null || value === '')
			return value;

		const n = MoneyHelper.parseCurrency(value, this.currencyGroupSeparator, this.currencyDecimalSeparator);
		return isNaN(n as any) ? value : n;
	}

	private formatNumber(value: any) {
		return MoneyHelper.formatNumber(value, this.currencyDecimalDigits);
	}
}
</script>